import HTTPClient from './http-client';

const END_POINT = '/public/hourlyforecast_pr';

const options = {
    cache: {
        maxAge: 5 * 60 * 1000,
        exclude: { query: false}
    }
}

const loadHourlyForecastWeather = async ({id}) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
        `${END_POINT}?location_id=${id}`,
        options
    );
};

export {
    loadHourlyForecastWeather,
}
